import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { IDriverSearchObject, IActiveTripResponseV2, ISimpleDriverDTO, IVehicleFilters } from 'src/types'
import { off, title } from 'process'
import { MoonLoader } from 'react-spinners'
import Modal from 'src/components/ui/Modal'
import UIMessages from 'src/utils/ui-messages'
import { MbscSelectCloseEvent, MbscSelectData, Select } from '@mobiscroll/react-latest'
import { NotificationProvider } from 'src/components/ui/notification-provider'

interface IAssignVehicleOperatorProps extends RouteComponentProps {
  vehicleId: string
  isFetching: boolean
  currentOrganizationId: string
  operators: IDriverSearchObject[]
  filters: IVehicleFilters
  onClose: () => void
  fetchOperators: (organizationId: string) => Promise<any>
  assignDriver: (vehicleId: string, operatorId: string, params: IVehicleFilters) => Promise<any>
}

const AssignVehicleOperator = (props: IAssignVehicleOperatorProps) => {
  const [operatorOptions, setOperatorOptions] = React.useState<MbscSelectData[]>([])
  const [selectedOperator, setSelectedOperator] = React.useState({ text: '', value: '' })
  const notification: any = React.useContext(NotificationProvider)
  const onChange = (option: MbscSelectCloseEvent) => {
    setSelectedOperator({ text: option.valueText, value: option.value })
  }
  const assignDriver = () => {
    if (selectedOperator.value.length === 36) {
      props.assignDriver(props.vehicleId, selectedOperator.value, props.filters).then(() => {
        notification.addNotification({
          title: 'Successfully assigned operator.',
          level: 'success',
          autoDismiss: 5
        })
        props.onClose()
      })
    }
  }
  React.useEffect(() => {
    props.fetchOperators(props.currentOrganizationId)
  }, [])
  React.useEffect(() => {
    if (props.operators) {
      const operators = props.operators.map(op => {
        return { text: op.name, value: op.id }
      })
      if (operators.length > 0) {
        setOperatorOptions(operators)
      } else {
        setOperatorOptions([{ text: 'No Operators Available', value: '' }])
      }
    }
  }, [props.operators])
  return (
    <Modal>
      <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
        <div className='med-modal'>
          <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
            {UIMessages.trip.assign} OPERATOR
          </span>
          <div className='mt1 border-top pt2'>
            <div className='mb1'>
              <Select
                name='SelectOperator'
                clearable={false}
                value={selectedOperator.text}
                filter={true}
                onClose={onChange}
                data={operatorOptions}
                touchUi={false}
                placeholder='Select Operator'
                theme='ios'
                themeVariant='light'
                inputStyle='box'
                label={`Operators`}
                labelStyle='floating'
              />
            </div>
            {/* <div>{this.state.error.length ? <p className='font-red m0'>{this.state.error}</p> : null}</div> */}
          </div>
          {props.isFetching === true ? (
            <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
          ) : (
            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={props.onClose}
                disabled={props.isFetching}
                className='CancelButton mbsc-gray-btn custom-btn'
              >
                {UIMessages.common.cancel}
              </button>
              <div title={title} className='ml1 cursor--pointer'>
                <button
                  type='button'
                  onClick={assignDriver}
                  disabled={props.isFetching}
                  className='SubmitButton custom-btn mbsc-green-btn'
                >
                  {UIMessages.trip.assign}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default AssignVehicleOperator



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/AssignVehicleOperator.tsx